import { date } from '@beelday/common'
import { useSelector } from 'app-redux'
import { redux as scriptRedux } from 'features/script'
import { useNow } from 'presenter-mode/use-now'
import { groupWorkEnd } from './group-work-end'

/** Looked at again every so often: a plan can pass while the screen stays. */
const LOOK_AGAIN_MS = 30 * 1000

/**
 * The planned end of the group work on screen, the user's way (`14:20`, or
 * `2:20 PM`), or `undefined` when there is none (`groupWorkEnd`).
 */
export const useGroupWorkEnd = (): string | undefined => {
	const current = useSelector(scriptRedux.selectCurrentScriptStep)
	const now = useNow(LOOK_AGAIN_MS)
	const { formatTime } = date.useDateFormat()
	const end = groupWorkEnd(current, now)
	return end ? formatTime(end) : undefined
}
